
import KTHeader from "@/layout/joymeet/header/Header.vue";
import KTFooter from "@/layout/joymeet/footer/Footer.vue";

export default {
    components: {
        KTHeader,
        KTFooter
    },
};
